
/**
 * Load dependencies
 */

import Vue from 'vue';

// Imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from 'bootstrap-vue';
Vue.use(LayoutPlugin);

// Imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from 'bootstrap-vue';
Vue.use(CardPlugin);

// Imports <b-navbar> along with all the <b-navbar-*> sub-components as a plugin:
import { NavbarPlugin } from 'bootstrap-vue';
Vue.use(NavbarPlugin);

// Imports <b-breadcrumb>
import { BreadcrumbPlugin } from 'bootstrap-vue';
Vue.use(BreadcrumbPlugin);

// Imports <b-form>
import { FormPlugin } from 'bootstrap-vue';
Vue.use(FormPlugin);

// Imports <b-form-group>
import { FormGroupPlugin } from 'bootstrap-vue';
Vue.use(FormGroupPlugin);

// Import <b-form-input>
import { FormInputPlugin } from 'bootstrap-vue';
Vue.use(FormInputPlugin);

// Import <b-form-select>
import { FormSelectPlugin } from 'bootstrap-vue';
Vue.use(FormSelectPlugin);

// Import <b-form-checkbox>
import { FormCheckboxPlugin } from 'bootstrap-vue';
Vue.use(FormCheckboxPlugin);

// Import <b-form-radio>
import { FormRadioPlugin } from 'bootstrap-vue';
Vue.use(FormRadioPlugin);

// This imports <b-breadcrumb> along with all the <b-breadcrumb-*> sub-components as a plugin:
import { ButtonPlugin } from 'bootstrap-vue';
Vue.use(ButtonPlugin);

// Imports <b-modal>
import { ModalPlugin } from 'bootstrap-vue';
Vue.use(ModalPlugin);

// Imports <b-spinner>
import { SpinnerPlugin } from 'bootstrap-vue';
Vue.use(SpinnerPlugin);

// Imports <b-pagination>
import { PaginationPlugin } from 'bootstrap-vue';
Vue.use(PaginationPlugin);


import router from './router/index.js';
import store from '@js/store';

import '@js/setup.js';

/**
 * Create a Vue application instance
 */

import App from '@component/user-backend/App.vue';

import sharedSetup from '@js/vue-setup.js';
Vue.use(sharedSetup);

import CheckoutErrorHandler from '../plugins/CheckoutErrorHandler';
Vue.use(CheckoutErrorHandler);

new Vue({
	router,
	el: '#app',
	store,
	render: h => h(App)
});
